module.exports = "<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"col-md-10\" style=\"float: none; margin: 0 auto;\">\n            <div ui-view></div>\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/company_configuration/company-configuration.html
// module id = 527
// module chunks = 0